<template>
    <div class="main" :style="bgStyle">
        <!-- <LangSwitcher v-model="selectValue" :options="options" /> -->
        <div v-for="(item, index) in newArr" :key="index">
            <!-- 移动端模板（待实现） -->
            <div class="information">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                    <el-form-item prop="id">
                        <div class="label">{{ item[4] }}:</div>
                        <el-input
                            v-model="ruleForm.id"
                            :placeholder="item[4]"
                            oninput="if(value.length>100)value=value.slice(0,100)"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="redemption">
                        <div class="label">{{ item[5] }}:</div>
                        <el-input
                            v-model="ruleForm.redemption"
                            :placeholder="item[5]"
                            oninput="if(value.length>100)value=value.slice(0,100)"
                        ></el-input>
                    </el-form-item>
                    <div>
                        <el-form-item prop="verification">
                            <div class="label">{{ item[6] }}:</div>
                            <div class="verify">
                                <el-input v-model="ruleForm.verification" :placeholder="item[6]" id="verify"></el-input>
                                <div class="code" @click="refresh">
                                    <div v-show="!codeLoaded" class="code-loading">
                                        <div class="spinner"></div>
                                    </div>
                                    <img v-show="codeLoaded" :src="verificationCode" alt="" @load="codeLoaded = true" />
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <div class="gText">*{{ item[10] }}</div>
                        </el-form-item>
                    </div>
                    <el-form-item>
                        <div class="exchange">
                            <div @click="submitForm" style="display: inline-block">
                                <img :src="moBtnImg" alt="" />
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <!-- <div class="exhibit">
                <p>&copy; 2021 HABBY PTE. LTD. All Rights Reserved.</p>
            </div> -->
            <ConfirmModal
                :visible="isModal"
                :loading="isLoading"
                :isMessage="isMessage"
                :title="'ID: ' + ruleForm.id"
                :subtitle="item[33]"
                :message="message"
                @yes="handleYes"
                @no="handleNo"
                @ok="handleOk"
            />
        </div>
    </div>
</template>

<script>
import giftExchange from '@/mixins/giftExchange'
import ConfirmModal from './ConfirmModal.vue'

const bgMap = {
    'en': require('@/assets/images/mo/en.png'),
    'ja': require('@/assets/images/mo/jp.png'),
    'ko': require('@/assets/images/mo/kr.png'),
    'zh-TW': require('@/assets/images/mo/zh.png')
}

const redeemMap = {
    'en': require('@/assets/images/mo/Redeem.png'),
    'ja': require('@/assets/images/mo/Redeem_jp.png'),
    'ko': require('@/assets/images/mo/Redeem_kr.png'),
    'zh-TW': require('@/assets/images/mo/Redeem_zh.png')
}

const exchangeMap = {
    'en': require('@/assets/images/mo/exchange_en.png'),
    'ja': require('@/assets/images/mo/exchange_jp.png'),
    'ko': require('@/assets/images/mo/exchange_kr.png'),
    'zh-TW': require('@/assets/images/mo/exchange_zh.png')
}

export default {
    mixins: [giftExchange],
    components: { ConfirmModal },
    computed: {
        bgStyle() {
            var bg = bgMap[this.selectValue] || bgMap['en']
            return {
                backgroundImage: 'url(' + bg + ')',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center top',
                backgroundSize: '100% 100%'
            }
        },
        moBtnImg() {
            var lang = this.selectValue || 'en'
            return this.isDisable
                ? (exchangeMap[lang] || exchangeMap['en'])
                : (redeemMap[lang] || redeemMap['en'])
        }
    }
}
</script>

<style scoped lang="less">
@import '../styles/mo.less';
</style>
